// particles.ts

const canvas = document.getElementById('particles-canvas') as HTMLCanvasElement | null;
const ctx = canvas?.getContext('2d');

if (canvas && ctx) {
	const context = ctx;

	function resizeCanvas() {
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
	}

	resizeCanvas();
	window.addEventListener('resize', resizeCanvas);

	class Particle {
		x: number;
		y: number;
		vx: number;
		vy: number;
		size: number;
		color: string;
		alpha: number;

		constructor() {
			this.x = Math.random() * canvas.width;
			this.y = Math.random() * canvas.height;
			this.vx = (Math.random() - 0.5) * 2;
			this.vy = (Math.random() - 0.5) * 2;
			this.size = Math.random() * 3 + 1;
			this.color = `hsl(${Math.random() * 60 + 200}, 70%, 60%)`;
			this.alpha = Math.random() * 0.5 + 0.2;
		}

		update() {
			this.x += this.vx;
			this.y += this.vy;

			if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
			if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
		}

		draw() {
			context.save();
			context.globalAlpha = this.alpha;
			context.fillStyle = this.color;
			context.beginPath();
			context.arc(this.x, this.y, this.size, 0, Math.PI * 2);
			context.fill();
			context.restore();
		}
	}

	const particles: Particle[] = [];
	const particleCount = 50;

	for (let i = 0; i < particleCount; i++) {
		particles.push(new Particle());
	}

	let mouse = {
		x: null as number | null,
		y: null as number | null,
		radius: 150
	};

	canvas.addEventListener('mousemove', (e) => {
		mouse.x = e.x;
		mouse.y = e.y;
	});

	canvas.addEventListener('mouseleave', () => {
		mouse.x = null;
		mouse.y = null;
	});

	function animate() {
		context.clearRect(0, 0, canvas.width, canvas.height);

		particles.forEach(particle => {
			particle.update();
			particle.draw();

			if (mouse.x !== null && mouse.y !== null) {
				const dx = mouse.x - particle.x;
				const dy = mouse.y - particle.y;
				const distance = Math.sqrt(dx * dx + dy * dy);

				if (distance < mouse.radius) {
					const force = (mouse.radius - distance) / mouse.radius;
					const angle = Math.atan2(dy, dx);
					const pushX = Math.cos(angle) * force * 2;
					const pushY = Math.sin(angle) * force * 2;

					particle.x -= pushX;
					particle.y -= pushY;
				}
			}
		});

		particles.forEach((particle, index) => {
			for (let j = index + 1; j < particles.length; j++) {
				const dx = particle.x - particles[j].x;
				const dy = particle.y - particles[j].y;
				const distance = Math.sqrt(dx * dx + dy * dy);

				if (distance < 100) {
					context.save();
					context.globalAlpha = (100 - distance) / 100 * 0.3;
					context.strokeStyle = '#3b82f6';
					context.lineWidth = 1;
					context.beginPath();
					context.moveTo(particle.x, particle.y);
					context.lineTo(particles[j].x, particles[j].y);
					context.stroke();
					context.restore();
				}
			}
		});

		requestAnimationFrame(animate);
	}

	animate();
}
